import * as R from "ramda";

export const filterProduct = (products: ApiProductsDetail[]) => {
  return R.uniqWith(R.eqProps("name"))(products);
};
